import { Decimal } from 'decimal.js';
import { decimalMax } from '@/lib/codecimal.js';
import _ from 'lodash';
import { decimalSum, coDecimalSum } from '@/lib/codecimal.js';
import { uuidv4 } from "@/lib/prelude.js";
import * as boissons from "@/models/boissons.js";
import { mapped, mappedCompte, filter, totalize } from '@/lib/counted.js';
import { Classes, viande, } from "@/models/model.js";

// price based on length of the item list
//+ IntervalMap -> (-Decimal) -> number
const cardpriceN = (imap, number) => imap.get(number).prix;

// price based on the sum of each item price
//+ [Item:price] -> (-Decimal) -> number
const compositeprice = items => decimalSum(items.map(i => i.price))

// price based on the sum of each item price times its qty
//+ [{count, Item:price}] -> (-Decimal) -> number
const qtycompositeprice = o => {
  let prices = Object.keys(o).map(k => totalize(o[k]))
  return decimalSum(prices).toNumber()
};

//+ [counted<item>] => number
const ajustedprice = viandes => {
    let priceyAndSelected = v => v.count > 0 && v.item.price > 0
    let viandesCheres = filter(priceyAndSelected)(viandes).map(totalize)
    return decimalSum(viandesCheres).toNumber()
}

//+ -> (-Decimal) -> {
//  pViandes,
//  pSauces,
//  pPain,
//  pCondiments,
//  pLegumes,
//  pFromages,
//  pBobos,
//  pBoissons,
//  total: number
// }
function price({ viandes, sauces, pain, condiments, legumes, fromages, bobos, boissons, offert }) {
  if (offert == true) {
    return {
        prixViandes: 0,
        prixSauces: 0,
        prixPain: 0,
        prixCondiments: 0,
        prixLegumes: 0,
        prixFromages: 0,
        prixBobos: 0,
        prixBoissons: 0,
        total:0
    };
  } else {
    let prixViandes = cardpriceN(Classes, mappedCompte(viandes)) + ajustedprice(viandes);
    let prixSauces = compositeprice(sauces);
    let prixPain = compositeprice(pain);
    let prixCondiments = compositeprice(condiments);
    let prixLegumes = compositeprice(legumes);
    let prixFromages = compositeprice(fromages);
    let prixBobos = compositeprice(bobos);
    let prixBoissons = qtycompositeprice(boissons);
    let total = decimalSum([prixViandes, prixSauces, prixPain, prixCondiments,
                            prixLegumes, prixFromages, prixBobos, prixBoissons]).toNumber();
    return {
      prixViandes,
      prixSauces,
      prixPain,
      prixCondiments,
      prixLegumes,
      prixFromages,
      prixBobos,
      prixBoissons,
      total
    };
  }
}

function priceN(menus) {
  let couts = menus.map(m => price(m).total);
  return coDecimalSum(couts);
}

//+ menu -> string
function classe(d) {
    let n = mappedCompte(d.viandes)
    return Classes.get(n).nom;
}

function updateViande(menu, viande, delta) {
    let nom = viande.nom
    if (nom in menu.viandes) {
        let c = menu.viandes[nom].count
        let n = c + delta
        if (n >= 0) {
            menu.viandes[nom].count = n
        }
    } else {
        menu.viandes[nom] = { count: 0, item: viande }
    }
}

const viandesEmpty = () => {
    return mapped(viande, v => v.nom)
};

const clone = menu => {
    let n = _.cloneDeep(menu)
    n.uid = uuidv4()
    return n
}

const zero = menu => {
    Object.assign(menu, empty());
}

/// rabais

const incRabais = (rabais, step=0.5) => new Decimal(rabais).add(new Decimal(step)).toNumber()
const decRabais = (rabais, step=0.5) => decimalMax(new Decimal(rabais).sub(new Decimal(step)), new Decimal(0)).toNumber()
const zeroRabais = () => new Decimal(0)
const updateRabais = newValue => new Decimal(newValue).toNumber()

//+ -> menu
function empty () {
  return {
    uid: uuidv4(),
    offert: false,
    viandes: viandesEmpty(),
    sauces: [],
    pain: [],
    condiments: [],
    legumes: [],
    fromages: [],
    bobos: [],
    boissons: boissons.empty(),
    nom: ""
  };
}

//+ menu -> boolean
function valid(menu) {
    return price(menu).total >= 0;
}

export { price, priceN, classe, clone, zero, empty, valid, updateViande, incRabais, decRabais, zeroRabais, updateRabais };
